// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","filterCheckbox":"_27s15VsaqTIGrmMA6Gk5V9"};